export default __webpack_public_path__ + "static/textile_city_forgery-70ad112e48dfe9a6a7428d2a070956d2.png";